/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sla_WarningInputs */

const vi_sla_warning = /** @type {(inputs: Sla_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cảnh báo (phút)`)
};

/**

* @param {Sla_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sla_warning = /** @type {((inputs?: Sla_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sla_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sla_warning(inputs)
});